import React from 'react';

const Groups = ({ data, settings = {}, onItemClick }) => {
  if (!data || data.length === 0) {
    return <div className="pco-empty"><p>No groups available at this time. Check back soon!</p></div>;
  }

  const layout = settings['pco-layout'] || 'cards';
  const groupType = settings['pco-group-type'] || 'all';
  const count = settings['pco-count'] || 'all';

  let filtered = data;
  if (groupType && groupType !== 'all') {
    filtered = filtered.filter(g => g.group_type_id === groupType);
  }
  const limit = count === 'all' ? filtered.length : parseInt(count, 10);
  const visible = filtered.slice(0, limit);

  if (!visible.length) {
    return <div className="pco-empty"><p>No groups available at this time.</p></div>;
  }

  if (layout === 'list') {
    return (
      <div className="pco-groups-list">
        {visible.map(group => (
          <div className="pco-list-item" key={group.id}>
            {group.image_url ? (
              <img className="pco-list-image" src={group.image_url} alt={group.name} loading="lazy" />
            ) : (
              <div className="pco-list-image" />
            )}
            <div className="pco-list-details">
              <h3>{group.name}</h3>
              <div className="pco-meta">
                {group.schedule && <span>📅 {group.schedule}</span>}
                {group.location && <span>📍 {group.location}</span>}
              </div>
              {group.description && <p>{group.description}</p>}
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Cards (default)
  return (
    <div className="pco-groups-grid">
      {visible.map(group => (
        <div className="pco-card" key={group.id}>
          {group.image_url ? (
            <img className="pco-card-image" src={group.image_url} alt={group.name} loading="lazy" />
          ) : (
            <div className="pco-card-image" />
          )}
          <div className="pco-card-body">
            {group.enrollment_status && (
              <span className="pco-badge">{group.enrollment_status}</span>
            )}
            <h3>{group.name}</h3>
            <div className="pco-meta">
              {group.schedule && <span>📅 {group.schedule}</span>}
              {group.location && <span>📍 {group.location}</span>}
            </div>
            {group.description && <p>{group.description}</p>}
            {onItemClick ? (
              <button className="button" onClick={() => onItemClick(group.id)}>Learn More</button>
            ) : (
              <a className="button" href={group.url || '#'} data-turbolinks="false">Learn More</a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Groups;
